import React, { Component } from 'react'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import styles from './index.module.less'

export default class extends Component {
  render() {
    const { status, reason } = this.props
    return (
      <>
        {status == 3 && (
          <p className={styles.checkTip}>
            <ExclamationCircleOutlined style={{ marginRight: 6 }} />审核中！审核结束后，您将收到我们的通知。
          </p>
        )}
        {status == 4 && (
          <p className={styles.checkTip}>未通过审核。原因：{reason}</p>
        )}
      </>
    )
  }
}
